import { z } from 'zod';
import { documentStatusSchema, documentTypeSchema } from './enums.js';

export const requestUploadSchema = z.object({
  projectId: z.string().uuid(),
  documentType: documentTypeSchema,
  filename: z.string().trim().min(1).max(255),
  contentType: z.string().trim().min(1).max(120),
  sizeBytes: z.number().int().positive().max(50 * 1024 * 1024),
});
export type RequestUploadInput = z.infer<typeof requestUploadSchema>;

export const confirmUploadSchema = z.object({
  documentId: z.string().uuid(),
});
export type ConfirmUploadInput = z.infer<typeof confirmUploadSchema>;

export const reviewDocumentSchema = z
  .object({
    status: z.enum(['valide', 'refuse', 'a_completer']),
    reason: z.string().trim().max(500).optional(),
  })
  .refine((data) => data.status === 'valide' || !!data.reason, {
    message: 'Motif requis pour un refus ou une demande de complément',
    path: ['reason'],
  });
export type ReviewDocumentInput = z.infer<typeof reviewDocumentSchema>;

export const documentSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  documentType: documentTypeSchema,
  filename: z.string(),
  contentType: z.string(),
  sizeBytes: z.number(),
  s3Key: z.string(),
  status: documentStatusSchema,
  reviewReason: z.string().nullable(),
  uploadedAt: z.string().datetime(),
  reviewedAt: z.string().datetime().nullable(),
});
export type DocumentRecord = z.infer<typeof documentSchema>;
